import { ChangeDetectorRef, Component } from '@angular/core';
import { BasePlugin } from '../../base-plugin.component';
import { PluginComponent } from '../../plugin.component';
import { Inspection } from '../../../shared/models/inspection.model';

@Component({
    templateUrl: './dimension.component.html',
    standalone: false
})
export class InstallationDimensionPluginComponent {
  public dimensions: any;
  public config: any;
  public editRoute = ['installation', 'dimension', 'edit'];
  constructor(private cdRef: ChangeDetectorRef) {}

  setConfig(config: any, inspection: Inspection, plugin: any) {
    this.config = config;
    this.initData();
    this.cdRef.detectChanges();
  }

  private initData() {
    this.dimensions = this.config.Dimensions;
  }
}
PluginComponent.plugins['installationdimensions'] = InstallationDimensionPluginComponent;
